import React, { lazy } from 'react';
import { PageBanner } from '../components/PageBanner';
import { motion } from 'framer-motion';
import { CalendarIcon, ClockIcon, MailIcon, CheckCircleIcon } from 'lucide-react';
export function BookingPage() {
  const features = [{
    icon: CalendarIcon,
    text: 'Choose your preferred date'
  }, {
    icon: ClockIcon,
    text: 'Select a convenient time slot'
  }, {
    icon: MailIcon,
    text: 'Receive email confirmation & reminders'
  }];
  return <main className="bg-white" data-id="element-307">
      <PageBanner title="Book Appointment" subtitle="Schedule your fingerprinting appointment online in just a few clicks." data-id="element-308" />

      <section className="py-16 bg-white" data-id="element-309">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-310">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} data-id="element-311">
            {/* Booking Info */}
            <div className="text-center mb-10" data-id="element-312">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#F0F4FF] rounded-full border border-[#E7ECF8] mb-4" data-id="element-313">
                <CalendarIcon className="h-4 w-4 text-[#4AA6CF]" data-id="element-314" />
                <span className="text-sm font-medium text-[#1E1F55]" data-id="element-315">
                  Online Scheduling
                </span>
              </div>
              <p className="text-gray-600 max-w-xl mx-auto leading-relaxed mb-6" data-id="element-316">
                Select your preferred service, date, and time below.
                Appointments are scheduled every 15 minutes.
              </p>

              {/* Feature Highlights */}
              <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-8" data-id="element-317">
                {features.map((feature, i) => <div key={i} className="flex items-center gap-2 text-sm text-gray-500" data-id="element-318">
                    <feature.icon className="h-4 w-4 text-[#4AA6CF]" data-id="element-319" />
                    <span data-id="element-320">{feature.text}</span>
                  </div>)}
              </div>
            </div>

            {/* Zoho Bookings Iframe */}
            <div className="rounded-2xl border border-gray-200 overflow-hidden shadow-sm bg-gray-50" data-id="element-321">
              <iframe src="https://ambientfingerprintingsolutions.zohobookings.com/portal-embed#/4623993000000036016" width="100%" height="700" title="Book an Appointment - Ambient Fingerprinting" style={{
              border: 0,
              display: 'block',
              minHeight: '600px'
            }} loading="lazy" allowFullScreen data-id="element-322"></iframe>
            </div>

            {/* Pricing Quick Reference */}
            <div className="mt-10 grid sm:grid-cols-2 gap-4" data-id="element-323">
              <div className="bg-[#F0F4FF] rounded-xl p-5 border border-[#E7ECF8] flex items-center gap-4" data-id="element-324">
                <div className="bg-white p-2.5 rounded-lg shadow-sm" data-id="element-325">
                  <CheckCircleIcon className="h-5 w-5 text-[#4AA6CF]" data-id="element-326" />
                </div>
                <div data-id="element-327">
                  <p className="text-sm font-bold text-[#1E1F55]" data-id="element-328">
                    Office Appointment
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-329">
                    $65.25 — all fees included
                  </p>
                </div>
              </div>
              <div className="bg-[#F0F4FF] rounded-xl p-5 border border-[#E7ECF8] flex items-center gap-4" data-id="element-330">
                <div className="bg-white p-2.5 rounded-lg shadow-sm" data-id="element-331">
                  <CheckCircleIcon className="h-5 w-5 text-[#4AA6CF]" data-id="element-332" />
                </div>
                <div data-id="element-333">
                  <p className="text-sm font-bold text-[#1E1F55]" data-id="element-334">
                    Mobile / Group
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-335">
                    $70.25 per person — 5+ people
                  </p>
                </div>
              </div>
            </div>

            {/* Help Text */}
            <p className="text-center text-sm text-gray-500 mt-8" data-id="element-336">
              Having trouble booking? Call us directly at{' '}
              <a href="tel:4105255285" className="text-[#4AA6CF] font-medium hover:underline" data-id="element-337">
                410-525-5285
              </a>
            </p>
          </motion.div>
        </div>
      </section>
    </main>;
}